import './Auth.css';

function EmailSubmitted(){

    return(
        <>
             <div className='logincontainer'>
             <form className='loginform' style={{width:"500px",height:"200px",display:'flex',justifyContent:'center',
                        alignItems:'center'
                    }}>
                           <h3> Your reset password request has been sent to your email ID! <br/>
                            Kindly check your email ID!
                           </h3>
                           {/* <section className='loginbuttons' style={{marginBottom:"35px",marginTop:"20px"}}>
                                <button className='loginbutton' style={{width:"200px"}}>Return to Login Pa</button>
                            </section> */}
                    </form>
             </div>
        </>
        );

}

export default EmailSubmitted;